module.exports = __webpack_public_path__ + "img/hand-back-fist.4834db8f.svg";